import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=422e7c05&scoped=true&"
import script from "./Toolbar.vue?vue&type=script&lang=ts&"
export * from "./Toolbar.vue?vue&type=script&lang=ts&"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=422e7c05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e7c05",
  null
  
)

export default component.exports